export const COMMENTS = 0
export const IMPORTANT = 1
export const ALL = 2
